module.exports = __webpack_public_path__ + "img/rate.5a1be584.svg";